import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import ToggleSwitch from "../../components/Custom/Forms/ToggleSwitch/ToggleSwitch";
import { responseToaster } from "../../helperFunctions";
import { useRole, useUser } from "../../redux/slices/authSlice";
import { pgUpdateVpaStatus } from "../../redux/slices/pgSlice";
import { getPgIdFromPgName } from "./Pg";

const PgVpaStatus = (props) => {
  const {
    data,
    pgData,
    setPgData,
    columns,
    updateVpaStatusIsLoading,
    setupdateVpaStatusIsLoading,
  } = props;

  const dispatch = useDispatch();
  const locations = useLocation()?.pathname?.split("/");
  const params = { pgName: locations?.at(-1), pgType: locations?.at(-2) };
  const isPayout = params?.pgType === "payout";
  const isUpiPay =
    (params?.pgName === "UPIPAY" && params?.pgType === "payin") ||
    (params?.pgName === "BANKPAY" && params?.pgType === "payin");
  const payinRole = useRole("PG Deposit Bank");
  const payoutRole = useRole("PG Withdrawal Bank");
  const { user } = useUser();

  const onUpdateVpsStatus = async (payload) => {
    try {
      setupdateVpaStatusIsLoading(payload?.pk);
      const res = await dispatch(
        pgUpdateVpaStatus({ params, payload })
      ).unwrap();
      const index = pgData?.data?.findIndex(
        (item) => item?.account_id === payload?.pk
      );
      if (index > -1) {
        const newData = [...pgData.data];
        newData[index] = { ...newData[index], is_VPA_enable: payload?.value };
        setPgData({ ...pgData, data: newData });
      }
      responseToaster(res);
      setupdateVpaStatusIsLoading(false);
    } catch (err) {
      setupdateVpaStatusIsLoading(false);
    }
  };

  return (
    <>
      {isPayout ? (
        <>
          <ToggleSwitch
            isLoading={updateVpaStatusIsLoading === data?.account_id}
            disabled={
              !!updateVpaStatusIsLoading ||
              !columns?.includes("is_VPA_enable") ||
              !(isPayout && payoutRole?.includes("pg-withdrawal-bank-update"))
            }
            className={`${!!updateVpaStatusIsLoading || !columns?.includes("is_VPA_enable")
                ? "disabled"
                : ""
              }`}
            value={data?.is_VPA_enable ? 1 : 0}
            onChange={async (value) => {
              const payload = {
                value: value,
                pk: data?.account_id,
                pg_id: getPgIdFromPgName(user?.SiderBar?.PG, params?.pgName),
              };
              await onUpdateVpsStatus(payload);
            }}
            style={{
              marginBottom: 5,
            }}
          />
        </>
      ) : null}
    </>
  );
};

export default PgVpaStatus;
